const breakPointSm = 641;
const breakPointMd = 768;
const breakPointLg = 1024;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowScrollPos = 0;



function _vwSP(size, base = 768) {
  windowWidth = window.innerWidth;
  return (size / base) * windowWidth;
}

function _vwPC(size, base = 1920) {
  windowWidth = window.innerWidth;
  return (size / base) * windowWidth;
}



// ------------------------------------------------------------------------
// スムーススクロール
// ------------------------------------------------------------------------
const anchorLink = () => {
  $('a.scroll[href^="#"]').on('click', function() {
    let linkSpeed    = 400;
    let linkHref     = $(this).attr('href');
    let linkTarget   = $(linkHref == '#' || linkHref == '' ? 'html' : linkHref);
    let linkPosition = linkTarget.offset().top;
    let linkAdjust   = 0;
    $('html, body').animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, 'swing');
    return false;
  });
};



// ------------------------------------------------------------------------
// ページトップの表示・非表示
// ------------------------------------------------------------------------
const pageTop = () => {
  let scrollHeight;
  let scrollPos;
  let footerHeight;
  let footerHeightAdjust;

  $(window).on('load scroll', function() {
    if( $(this).scrollTop() > 300 ) {
      $('.st-PageTop').fadeIn();
    } else {
      $('.st-PageTop').fadeOut();
    }

    scrollHeight = $(document).height();
    scrollPos = $(window).height() + $(window).scrollTop();
    if( windowWidth < breakPointSm ) {
      footerHeightAdjust = _vwSP(43) + _vwSP(30); //PageTopボタンのFooter停止位置＋fixed時のBottom値
    } else if( windowWidth >= breakPointSm && windowWidth < breakPointLg ) {
      footerHeightAdjust = 43 + 30; //PageTopボタンのFooter停止位置＋fixed時のBottom値
    } else {
      footerHeightAdjust = _vwPC(43) + _vwPC(30); //PageTopボタンのFooter停止位置＋fixed時のBottom値
    }
    footerHeight = $('footer').innerHeight() - footerHeightAdjust;

    if( scrollHeight - scrollPos <= footerHeight ) {
      $('.st-PageTop').removeClass('fixed');
    } else {
      $('.st-PageTop').addClass('fixed');
    }
  });
}



// ------------------------------------------------------------------------
// YouTube動画モーダル表示
// ------------------------------------------------------------------------
const showYouTubeModal = () => {
  $('.video_link').on('click', function() {
    let youtubeID = $(this).attr('data-youtube-id');
    let listID = $(this).attr('data-youtube-list');
    let html = '';

    //背景コンテンツ固定
    windowScrollPos = $(window).scrollTop();
    $('body').addClass('fixed').css({'top': -windowScrollPos});


    //モーダルボックス生成
    if( listID.length ) {
      html = '<iframe width="800" height="450" src="https://www.youtube.com/embed/videoseries?list=' + listID + '&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
    } else {
      html = '<iframe width="800" height="450" src="https://www.youtube.com/embed/' + youtubeID + '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
    }
    $('.sw-Modal .sw-Modal_Container .video_inner').append(html);
    $('.sw-Modal').fadeIn(300);

    return false;
  });


  //モーダルクローズ
  function modalClose() {
    //背景コンテンツ固定解除
    $('body').removeClass('fixed').css({'top': ''});
    $(window).scrollTop(windowScrollPos);

    //モーダルボックス非表示
    $('.sw-Modal').fadeOut(200);

    //コンテンツ破棄
    setTimeout(function() {
      $('.sw-Modal .sw-Modal_Container .video_inner').html('');
    }, 300);
  }

  $('.sw-Modal .btn_close').on('click', function() {
    modalClose();
    return false;
  });

  $(document).on('click', '.sw-Modal_Wrapper', function() {
    modalClose();
    return false;
  });
}



export {
  anchorLink,
  pageTop,
  showYouTubeModal,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js